import { render, staticRenderFns } from "./AutomaticInvestmentDisclaimer.vue?vue&type=template&id=7b287d59&"
import script from "./AutomaticInvestmentDisclaimer.vue?vue&type=script&lang=js&"
export * from "./AutomaticInvestmentDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports